import { useEffect, useState } from 'react';

import 'react-loading-skeleton/dist/skeleton.css';
import GetNewsResponse from '../../../../Api/CRM/Responses/NewsResponse';
import PageSettingsApi from '../../../../Api/PageSettingsApi';
import CasinoSiteApi from '../../../../casino/Api/SiteApi/CasinoSiteApi';
import useAutoPaginator from '../../../../crm/hooks/useAutoPaginator';

import DefaultTemplate from './Templates/DefaultTemplate';

type Props = {
    readonly displaynewsdate: boolean;
    readonly timezone: string;
    readonly appname: string;
    readonly defaultthumbnailsrc: string;
    readonly getallnews: string;
    readonly isNewsImgVisible: boolean;
};

function News({ displaynewsdate, timezone, appname, defaultthumbnailsrc, getallnews }: Props) {
    const [hiddenComponent, setHiddenComponent] = useState(true);
    const [isNewsImgVisible, setIsNewsImgVisible] = useState();
    const getAllNews: boolean = getallnews === 'true';
    const { items, updateItems, isLoading, auto } = useAutoPaginator<GetNewsResponse>((page, params) => {
        return CasinoSiteApi.getNews(getAllNews, page, { params });
    });

    useEffect(() => {
        setHiddenComponent(items.length <= 0);
        PageSettingsApi.isImgVisible().then((response) => {
            setIsNewsImgVisible(response.data);
        });
    }, [items]);

    function getContent() {
        return DefaultTemplate({
            news: items,
            loading: isLoading,
            hiddenComponent,
            displaynewsdate,
            timezone,
            defaultthumbnailsrc,
            appname,
            getAllNews,
            lastPage: auto.paginator.lastPage,
            currentPage: auto.paginator.currentPage,
            setCurrentPage: updateItems,
            isNewsImgVisible,
        });
    }

    return getContent();
}

export default News;
